import * as types from '../../mutations-types';
export default {
  [types.MOBILEGAME_SET_DETAIL]: (state, { game, categoryRange, sameDeveloper }) => {
    state.game = game.code === 1 ? game.data : []
    state.categoryRange = categoryRange.code === 1 ? categoryRange.data : []
    state.sameDeveloper = sameDeveloper.code === 1 ? sameDeveloper.data : []
  }
};
